import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";
import type { PaginationAndOrderParams } from "@src/shared/types/pagination.types";

export interface GetReturnsParams
  extends Partial<
    Omit<PaginationAndOrderParams, "page" | "pageSize" | "orderDirection">
  > {
  page?: number | string;
  pageSize?: number | string;
  search?: string;
  status?: string;
  businessId?: string | number;
  orderDirection?: TableSortValue;
}

export interface ProductReturnItemRecord {
  name?: string | null;
  quantity?: number;
  price?: number;
  totalAmount?: number;
  itemType?: string | null;
  imageUrl?: string | null;
  variants?: Array<{
    id: number;
    productId: number;
    price: number;
    shippingCost: number;
    taxRate: number;
    weight: number | null;
    length: number | null;
    width: number | null;
    height: number | null;
    status: string;
    createdAt: string;
    updatedAt: string;
  }>;
}

export interface ProductReturnTimelineRecord {
  id: number;
  status: string;
  createdAt: string;
}

export interface ProductReturnRefundRecord {
  id: number;
  refundAmount: number;
  cancellationFee: number;
  netRefundAmount: number;
  status: string;
  type?: string | null;
  action?: string | null;
  stripeRefundId?: string | null;
  createdAt: string;
  updatedAt?: string | null;
}

export interface ProductReturnRecord {
  id?: number | string;
  transactionId?: number | string;
  orderId?: number | string;
  transactionItemId?: number | string;
  userId?: number;
  productName?: string | null;
  businessName?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  reasonId?: number | null;
  reason?: string | null;
  customReason?: string | null;
  status?: string | null;
  refundAmount?: number;
  currency?: string | null;
  createdAt?: string;
  updatedAt?: string;
  approvedAt?: string | null;
  pickupScheduledAt?: string | null;
  pickedUpAt?: string | null;
  receivedAt?: string | null;
  inspectedAt?: string | null;
  approvedByName?: string | null;
  processedByName?: string | null;
  inspectionNote?: string | null;
  inspectionStatus?: string | null;
  images?: string[];
  timeline?: ProductReturnTimelineRecord[];
  refund?: ProductReturnRefundRecord | null;
  item?: ProductReturnItemRecord;
}

export class ProductReturnService {
  async getReturns(query: GetReturnsParams) {
    return apiService.get("/product-returns", {
      params: sanitizeQueryParams(query),
    });
  }

  async getReturn(id: string) {
    return apiService.get(`/product-returns/${id}`);
  }
}

export const productReturnService = new ProductReturnService();
